import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/api';

import Modal from "./Modal"

import ParadigmaTable from "../../../components/ParadigmaTable/ParadigmaTable"



class Encabezados extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Siglas",
                    id: "siglas",
                    accessor: d => d.siglas,
                    show: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        component: (props) => <Modal {...props} action="CREATE" />,
                        permission: 'configuracion_encabezados_new',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="EDIT" />,
                        permission: 'configuracion_encabezados_edit',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DETAIL" />,
                        permission: 'configuracion_encabezados_detail',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DELETE" />,
                        permission: 'configuracion_encabezados_delete',
                    }
                ]}
                apiUrl={api.configuracion.encabezados}
                columns={this.state.columns}
                exportUrl={api.configuracion.encabezados}
                title={"Encabezados"}
            />
        );
    }
}

export default Encabezados;



// WEBPACK FOOTER //
// ./src/views/Configuracion/Encabezados/Encabezados.js